import React from 'react';
export function Volleyball({
  className = 'w-6 h-6'
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-256">
      <circle cx="12" cy="12" r="10" data-id="element-257" />
      <path d="M12 2 Q 8 8 12 12 Q 16 8 12 2" data-id="element-258" />
      <path d="M12 22 Q 8 16 12 12 Q 16 16 12 22" data-id="element-259" />
      <path d="M2 12 Q 8 8 12 12 Q 8 16 2 12" data-id="element-260" />
      <path d="M22 12 Q 16 8 12 12 Q 16 16 22 12" data-id="element-261" />
    </svg>;
}